var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('span', {
    staticStyle: {
      "position": "relative"
    }
  }, [_c('v-icon', {
    staticClass: "video-voice",
    style: {
      opacity: _vm.opacity
    },
    attrs: {
      "large": ""
    }
  }, [_vm._v("mdi-circle-small")]), _c('v-icon', {
    attrs: {
      "large": "",
      "color": "grey lighten-5"
    }
  }, [_vm._v("mdi-circle-small")])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }